import { PageHead } from "../components/ui-bits";
import { ChatThread } from "../components/ChatThread";
import { useAuth } from "../context/AuthContext";

export default function Messages() {
  const { user } = useAuth();
  return (
    <div>
      <PageHead eyebrow="Talk To Your CFO Team" title="Messages" />
      <p className="text-sm text-[#555] mb-4">
        Direct line to your assigned agent{user?.assigned_agent_name ? ` — ${user.assigned_agent_name}` : ""}. Share updates, ask questions, get answers.
      </p>
      <div className="max-w-2xl">
        <ChatThread clientEmail={null} height="h-[calc(100vh-320px)]" />
      </div>
    </div>
  );
}
